import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { SaleFormData } from "@/types/sale";

interface SaleFormContentProps {
  formData: SaleFormData;
  onFormChange: (field: keyof SaleFormData, value: string) => void;
  isCredit: boolean;
  total: number;
}

export const SaleFormContent = ({
  formData,
  onFormChange,
  isCredit,
  total,
}: SaleFormContentProps) => {
  return (
    <div className="space-y-4">
      {isCredit && (
        <>
          <div>
            <Label htmlFor="customerName">Nom du client</Label>
            <Input
              id="customerName"
              value={formData.customerName}
              onChange={(e) => onFormChange("customerName", e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="customerContact">Contact du client</Label>
            <Input
              id="customerContact"
              value={formData.customerContact}
              onChange={(e) => onFormChange("customerContact", e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="customerAddress">Adresse du client</Label>
            <Input
              id="customerAddress"
              value={formData.customerAddress}
              onChange={(e) => onFormChange("customerAddress", e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="partialPayment">Paiement partiel</Label>
            <Input
              id="partialPayment"
              type="number"
              min="0"
              max={total.toString()}
              value={formData.partialPayment}
              onChange={(e) => onFormChange("partialPayment", e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="paymentDate">Date de paiement</Label>
            <Input
              id="paymentDate"
              type="date"
              value={formData.paymentDate}
              onChange={(e) => onFormChange("paymentDate", e.target.value)}
            />
          </div>
        </>
      )}
    </div>
  );
};